import { CanActivate,
		 ActivatedRouteSnapshot,
		 RouterStateSnapshot,
		 Router  
} from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { AuthenticationService } from './services/authentication.service';

@Injectable()
export class AuthGuard implements CanActivate {
	constructor(private authService: AuthenticationService, private router: Router){}
	canActivate(route: ActivatedRouteSnapshot,
				state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean{

		return this.authService.isAuthenticated()
		.then(
			(authenticated: boolean) => {
				if(authenticated){					
					return true;
				}else {
					if(localStorage.getItem("userRole") && localStorage.getItem("userRole") == "recruiter") {
						this.router.navigate(['/recruiter/dashboard']);
					} else if(localStorage.getItem("userRole") && localStorage.getItem("userRole") == "admin") {
						this.router.navigate(['/admin/dashboard']);
					} else {
						this.authService.logout();
					}
				}
				
			}
			);
	}

}


// WEBPACK FOOTER //
// ./src/app/auth-guard.service.ts